import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { ReasonCodes } from "../../../types/operations/osad.type";
import { http } from "../../../utils/httpCommon";
import { useApiUrls } from "../../useApiUrl";

export const useReasonCodes = (
  enabled = true
): UseQueryResult<ReasonCodes[], unknown> => {
  const hookUrls = useApiUrls();
  const urls = hookUrls;

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["reason-codes"],
    queryFn: async () => {
      const { data } = await http.get(urls.osad.getReasonCodes);
      return data;
    },
    enabled,
  });
};
